module.exports = __webpack_public_path__ + "img/Vector_nyertes_palyazat.ec61feb1.svg";